
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import Tooltip from './tooltip'
export const playgroundStyle = {
  paddingTop: '1em',
  justifyContent: 'center',
  display: 'flex'
};
export const inversePlaygroundStyle = {
  backgroundColor: "#333",
  margin: '-2em',
  padding: '3em 2em 2em',
  justifyContent: 'center',
  display: 'flex'
};

const layoutProps = {
  playgroundStyle,
inversePlaygroundStyle
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "tooltip"
    }}>{`Tooltip`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Controls`}</p>
    <hr />
    <h2 {...{
      "id": "tooltip-1"
    }}>{`Tooltip`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For displaying additional contextual information: composed of a tooltip label and tooltip balloon.
Position the tooltip balloon below the label by default, adjust where constrained by layout.`}</p>
    <p><strong parentName="p">{`North`}</strong></p>
    <Playground __position={1} __code={'<Tooltip labelText=\"Tooltip label\" balloonText=\"Tooltip balloon\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tooltip
    }} style={playgroundStyle} mdxType="Playground">
    <Tooltip labelText='Tooltip label' balloonText='Tooltip balloon' mdxType="Tooltip" />
    </Playground>
    <p><strong parentName="p">{`South`}</strong></p>
    <Playground __position={2} __code={'<Tooltip\n  labelText=\"Tooltip label\"\n  balloonText=\"Tooltip balloon\"\n  direction=\"south\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tooltip
    }} style={playgroundStyle} mdxType="Playground">
    <Tooltip labelText='Tooltip label' balloonText='Tooltip balloon' direction='south' mdxType="Tooltip" />
    </Playground>
    <p><strong parentName="p">{`East`}</strong></p>
    <Playground __position={3} __code={'<Tooltip\n  direction=\"left\"\n  labelText=\"Tooltip label\"\n  balloonText=\"Tooltip balloon\"\n  direction=\"east\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tooltip
    }} style={playgroundStyle} mdxType="Playground">
    <Tooltip direction='left' labelText='Tooltip label' balloonText='Tooltip balloon' direction='east' mdxType="Tooltip" />
    </Playground>
    <p><strong parentName="p">{`West`}</strong></p>
    <Playground __position={4} __code={'<Tooltip\n  labelText=\"Tooltip label\"\n  balloonText=\"Tooltip balloon\"\n  direction=\"west\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tooltip
    }} style={playgroundStyle} mdxType="Playground">
    <Tooltip labelText='Tooltip label' balloonText='Tooltip balloon' direction='west' mdxType="Tooltip" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "tooltip-inverse"
    }}>{`Tooltip (inverse)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For displaying additional contextual information: composed of a tooltip label and tooltip balloon.
Position the tooltip balloon below the label by default, adjust where constrained by layout.`}</p>
    <p><strong parentName="p">{`North`}</strong></p>
    <Playground __position={6} __code={'<Tooltip inverse labelText=\"Tooltip label\" balloonText=\"Tooltip balloon\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tooltip
    }} style={inversePlaygroundStyle} mdxType="Playground">
    <Tooltip inverse labelText='Tooltip label' balloonText='Tooltip balloon' mdxType="Tooltip" />
    </Playground>
    <p><strong parentName="p">{`South`}</strong></p>
    <Playground __position={7} __code={'<Tooltip\n  inverse\n  labelText=\"Tooltip label\"\n  balloonText=\"Tooltip balloon\"\n  direction=\"south\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tooltip
    }} style={inversePlaygroundStyle} mdxType="Playground">
    <Tooltip inverse labelText='Tooltip label' balloonText='Tooltip balloon' direction='south' mdxType="Tooltip" />
    </Playground>
    <p><strong parentName="p">{`East`}</strong></p>
    <Playground __position={8} __code={'<Tooltip\n  direction=\"left\"\n  inverse\n  labelText=\"Tooltip label\"\n  balloonText=\"Tooltip balloon\"\n  direction=\"east\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tooltip
    }} style={inversePlaygroundStyle} mdxType="Playground">
    <Tooltip direction='left' inverse labelText='Tooltip label' balloonText='Tooltip balloon' direction='east' mdxType="Tooltip" />
    </Playground>
    <p><strong parentName="p">{`West`}</strong></p>
    <Playground __position={9} __code={'<Tooltip\n  inverse\n  labelText=\"Tooltip label\"\n  balloonText=\"Tooltip balloon\"\n  direction=\"west\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tooltip
    }} style={inversePlaygroundStyle} mdxType="Playground">
    <Tooltip inverse labelText='Tooltip label' balloonText='Tooltip balloon' direction='west' mdxType="Tooltip" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Tooltip} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;